module.exports = __webpack_public_path__ + "static/img/logo-white-wide-small.2c5c634d.png";